
document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('.gt-faq-page');
  roots.forEach(function (root) {
    var headings = Array.prototype.slice.call(root.querySelectorAll('h3'));
    headings.forEach(function (h3, idx) {
      var p = h3.nextElementSibling;
      if (!p || p.tagName !== 'P') return;
      var details = document.createElement('details');
      details.className = 'g10-faq-item';
      if (idx === 0) details.setAttribute('open', '');
      var summary = document.createElement('summary');
      var q = document.createElement('span');
      q.className = 'g10-faq-q';
      q.textContent = h3.textContent;
      summary.appendChild(q);
      var answer = document.createElement('div');
      answer.className = 'g10-faq-a';
      answer.appendChild(p.cloneNode(true));
      details.appendChild(summary);
      details.appendChild(answer);
      h3.replaceWith(details);
      p.remove();
    });
  });
});
